import { Box, FormControl, FormLabel, Input, InputProps } from '@chakra-ui/react';
import { rem } from 'polished';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { shortHexToFullHex } from '@onbeam/utils';

interface Props extends Omit<InputProps, 'onChange'> {
  onChange: (hex: string) => void;
  colorPreset?: string;
}

export const Colorpicker = ({ onChange, defaultValue, colorPreset, ...props }: Props) => {
  const [inputValue, setInputValue] = useState(String(defaultValue));

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onChange(shortHexToFullHex(e.target.value));
    setInputValue(`#${e.target.value.replace(/#/g, '').substring(0, 6)}`);
  }, []);

  useEffect(() => {
    colorPreset && setInputValue(colorPreset);
  }, [colorPreset]);

  return (
    <FormControl role="group">
      <FormLabel display="flex" alignItems="stretch" m={0}>
        <Box
          p="space.8"
          borderLeftRadius="radius.8"
          border="1px solid"
          borderColor="gray.4"
          flexShrink={0}
          cursor="pointer"
          transition="border 200ms ease-in-out"
          _groupFocusWithin={{ borderColor: 'gray.5' }}
          _groupHover={{ borderColor: 'gray.5' }}
        >
          <Box h={rem(40)} w={rem(40)} rounded="radius.8" overflow="hidden">
            <Input
              cursor="pointer"
              onChange={handleChange}
              border="none"
              transform="scale(2)"
              p={0}
              type="color"
              value={shortHexToFullHex(inputValue)}
              {...props}
            />
          </Box>
        </Box>
        <Input
          px="space.4"
          textAlign="center"
          h="unset"
          borderLeftRadius="unset"
          borderLeft="unset"
          value={inputValue}
          onChange={handleChange}
          _groupFocusWithin={{ borderColor: 'gray.5' }}
          _groupHover={{ borderColor: 'gray.5' }}
          maxLength={7}
          onClick={e => (e.target as HTMLInputElement).select()}
        />
      </FormLabel>
    </FormControl>
  );
};
